import { error, finish } from '../../../modules/participants/actions/create';
import api from '../../../api';

export function request(dispatch, { data }) {
    const platformObject = data.platformObject ?? null;
    const sport = typeof data.sport === 'object' ? data.sport.id : data.sport;
    
    const requestBody = {
        name: data.name,
        sport,
        isCreation: true,
        ...(platformObject !== null ? { platformObject } : {})
    };

    $appState.sdkStaff.createParticipant({ requestBody }).then(
        participant => {
            if (participant.status > 400) {
                dispatch(error(participant.errors));
            } else {
                dispatch(finish({}));
            }
        },
        errors => dispatch(error(errors))
    );
}
